<h1 mat-dialog-title class="mbp-confirm-dialog__title">{{ initialized ? data.title : 'Loading...' }}</h1>

<div mat-dialog-content class="mbp-confirm-dialog__content company-search-dialog">
  @if (!initialized) {
    <mat-progress-bar mode="buffer"></mat-progress-bar>
  }
  @if (initialized) {
    <div class="company-search-dialog__filters">
      <mat-form-field appearance="outline" class="company-search-dialog__search" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          type="text"
          placeholder="Company name"
          aria-label="Company name"
          [formControl]="companyNameFilter" />
      </mat-form-field>
    </div>

    <mat-paginator
      class="company-search-dialog__paginator"
      [pageSizeOptions]="[5, 10, 15]"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [length]="totalNumberOfCompanies"
      showFirstLastButtons
      (page)="onPageChange($event)"
      aria-label="Select page of companies">
    </mat-paginator>

    <div class="mbp-table-wrap">
      <table mat-table [dataSource]="companiesDataSource" class="mbp-data-table company-list">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="name-col">Name</th>
          <td mat-cell *matCellDef="let selectable" class="name-col">{{ selectable.company.name }}</td>
        </ng-container>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let selectable">{{ getType(selectable.company) }}</td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let selectable">{{ selectable.company.email ? selectable.company.email : '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="phone_number">
          <th mat-header-cell *matHeaderCellDef>Phone number</th>
          <td mat-cell *matCellDef="let selectable">{{ selectable.company.phone_number ? selectable.company.phone_number : '-' }}</td>
        </ng-container>
        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef>Created</th>
          <td mat-cell *matCellDef="let selectable">{{ formatTime(selectable.company.created_at) }}</td>
        </ng-container>
        <ng-container matColumnDef="selected">
          <th mat-header-cell *matHeaderCellDef class="selected-col">Selected</th>
          <td mat-cell *matCellDef="let selectable" class="selected-col">
            <span class="company-search-dialog__checkbox">
              <mat-checkbox
                [disableRipple]="true"
                (click)="$event.preventDefault()"
                color="primary"
                [checked]="selectable.selected">
              </mat-checkbox>
            </span>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          class="company-search-dialog__row"
          [class.selected]="row.selected"
          (click)="selectCompany(row)"
          *matRowDef="let row; columns: displayedColumns;">
        </tr>
      </table>
    </div>
  }
</div>

<div mat-dialog-actions align="end" class="mbp-confirm-dialog__actions">
  <button type="button" mat-stroked-button [mat-dialog-close]="null">Cancel</button>
  <button
    type="button"
    mat-flat-button
    [disabled]="!selectedCompany || isLoading"
    [mat-dialog-close]="selectedCompany"
    color="primary"
    cdkFocusInitial
  >
    Apply
  </button>
</div>
